import React, { useEffect, useState } from 'react'
import { Link, useParams } from "react-router-dom";
import { List } from 'components/pages-article-list/list';
import { Pagination } from 'components/utils/pagination';
import { SideMenu } from 'components/utils/side-menu';
import { handleError } from 'config/libraries';

export const Section2 = () => {

    const [DataResponse, setDataResponse] = useState([]);

    useEffect(() => {

        const axios = require('axios');
        axios.get(process.env.REACT_APP_SERVER_BASE_URL + '/berita?per_page=6&page=1').then(function (response) {
            setDataResponse(response.data.data.data);
        }).catch(function (error) {
            handleError(error)
        })
        return () => {
            setDataResponse(null);
        };
    }, []);

    return (
        <section className="home_section2">
            <div className="container">
            <div className="row">
                <div className="col-md-12">
                <div id="blockid_72be465" className="block-section jl-main-block" data-blockid="blockid_72be465" data-name="jl_mgrid" data-page_max={11} data-page_current={1} data-author="none" data-order="date_post" data-posts_per_page={6} data-offset={5}>
                    <div className="jl_grid_wrap_f jl_clear_at g_3col">
                    <div className="jl-roww content-inner jl-col3 jl-col-row">
                        <div className="jl_sec_title">
                        <h3 className="jl_title_c"><span>Berita</span></h3>
                        <p>Informasi resmi terbaru dan terpercaya seputar Dinas Pendidikan</p>
                        </div>
                        {
                            DataResponse && DataResponse.map((item, index) => {
                                return (
                                    <div key={index} className="jl-grid-cols">
                                        <div className="p-wraper post-2959">
                                            <div className="jl_grid_w">
                                            <div className="jl_img_box jl_radus_e">
                                                <Link to={'/berita/' + item.slug_berita}>
                                                    <span className="jl_post_type_icon"><i className="jli-gallery" /></span>
                                                    <img width={500} height={350} src={process.env.REACT_APP_SERVER_IMAGE_URL + item.gambar_berita} className="attachment-sprasa_slider_grid_small size-sprasa_slider_grid_small wp-post-image" alt="" loading="lazy" />
                                                </Link>
                                                <span className="jl_f_cat">
                                                    <Link to={'/berita/' + item.slug_berita} className="post-category-color-text" style={{background: '#62ce5c'}} href="#">
                                                        {item.nama_kategori_berita}
                                                    </Link>
                                                </span>
                                            </div>
                                            <div className="text-box">
                                                <h3><Link to={'/berita/' + item.slug_berita}>{item.judul_berita}</Link></h3>
                                                <span className="jl_post_meta">
                                                <span className="post-date"><i className="jli-pen" />{item.created_at}</span>
                                                </span>
                                                <p>{item.sub_judul_berita}</p>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                )
                            })
                        }
                    </div>
                    <div className="jl_lmore_wrap">
                        <div className="jl_lmore_c">
                        <Link to={'/berita'} className="jl-load-link"><span>Selengkapnya</span></Link><span className="jl-load-animation"><span /></span>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </section>
    )
};